export const LOCATION_CODE_PATTERN = /^(GRP-)?[A-Z]{6}$/;

export const isValidLocationCode = (code) => LOCATION_CODE_PATTERN.test(code);

export const extractLocationCodeFromScan = (scannedText) => {
  const trimmed = (scannedText || "").trim();
  if (LOCATION_CODE_PATTERN.test(trimmed.toUpperCase())) {
    return trimmed.toUpperCase();
  }
  try {
    const url = new URL(trimmed);
    const match = url.pathname.match(/\/registration\/loc\/([^/]+)/i);
    if (match && match[1]) {
      return decodeURIComponent(match[1]).toUpperCase();
    }
  } catch (e) {
    // scanned text is not a URL, fall through and use it as-is
  }
  return trimmed.toUpperCase();
};
